import React, { useState } from "react";
import { sendSignupEmail } from "../lib/email";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function CTA() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [hp, setHp] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    if (hp) return;

    if (!name.trim()) {
      setStatus({ type: "error", msg: "Please enter your name." });
      return;
    }
    if (!EMAIL_REGEX.test(email)) {
      setStatus({ type: "error", msg: "Please enter a valid email." });
      return;
    }

    try {
      await sendSignupEmail({ name: name.trim(), email, source: "cta" });
      setStatus({ type: "success", msg: "Thanks! We’ll be in touch shortly." });
      setName("");
      setEmail("");
    } catch (err) {
      console.error(err);
      setStatus({ type: "error", msg: "Something went wrong. Try again." });
    }
  }

  return (
    <section className="lk-section lk-cta">
      <div className="lk-container lk-cta-inner">
        <div>
          <h2>Ready to stop missing leads?</h2>
          <p className="lk-lead">
            Get early access and a launch discount for LeadKey AI.
          </p>
        </div>
        <form className="lk-form inline" onSubmit={onSubmit}>
          {/* Honeypot */}
          <input
            type="text"
            name="company"
            value={hp}
            onChange={(e) => setHp(e.target.value)}
            tabIndex="-1"
            autoComplete="off"
            style={{ position: "absolute", left: "-9999px", height: 0, width: 0 }}
            aria-hidden="true"
          />

          <input
            type="text"
            name="name"
            placeholder="Your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            aria-label="Your name"
            required
          />
          <input
            type="email"
            name="email"
            placeholder="you@business.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            aria-label="Email address"
          />
          <button type="submit">Join the Waitlist</button>
        </form>
        {status.msg && (
          <p
            className={
              status.type === "success" ? "lk-msg success" : "lk-msg error"
            }
            role="status"
          >
            {status.msg}
          </p>
        )}
      </div>
    </section>
  );
}
